import { OptionType } from '@evinced-private/ui-common';

import { ConfigurationLabel } from '../../../common/types/ConfigurationTypes';

import { sanitizeConfigurationLabel } from './DataSanitizationHelpers';

export const createOptionsFromAdditionalLabels = (
	additionalLabels: ConfigurationLabel[]
): Record<string, OptionType[]> => {
	const options: Record<string, OptionType[]> = {};

	additionalLabels.forEach((label, index) => {
		const sanitized = sanitizeConfigurationLabel(label);

		if (sanitized.showAsFilter && sanitized.values.length > 0) {
			const filterId = sanitized.label || `additionalLabel_${index}`;

			options[filterId] = sanitized.values.map((value) => ({
				value: String(value),
				label: String(value)
			}));
		}
	});

	return options;
};

export const createOptionsFromCoreLabels = (
	coreLabels: ConfigurationLabel[],
	pathname: string,
	isBusinessUnitsRoute: (pathname: string) => boolean
): Record<string, OptionType[]> => {
	const options: Record<string, OptionType[]> = {};
	const isOnBusinessUnitsRoute = isBusinessUnitsRoute(pathname);

	coreLabels.forEach((label, index) => {
		const sanitized = sanitizeConfigurationLabel(label);

		if (sanitized.label) {
			const filterId = sanitized.label || `coreLabel_${index}`;
			const isBusinessUnitFilter = filterId === 'unitId';

			// Skip business-unit options when on business units route
			if (!(isBusinessUnitFilter && isOnBusinessUnitsRoute) && sanitized.values.length > 0) {
				options[filterId] = sanitized.values.map((value) => ({
					value: String(value),
					label: String(value)
				}));
			}
		}
	});

	return options;
};

export const combineFilterOptions = (
	...optionObjects: Record<string, OptionType[]>[]
): Record<string, OptionType[]> => {
	return optionObjects.reduce((combined, options) => {
		Object.assign(combined, options);
		return combined;
	}, {});
};
